import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { ProfilQuerySorterConfig } from 'fa-kt.types';
import { ProfilService } from '../service';

@Component({
  selector: 'fa-kt-profil-sorter',
  templateUrl: './profil-sorter.component.html',
  styleUrls: ['./profil-sorter.component.css'],
})
export class ProfilSorterComponent {
  public ProfilSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public profil: ProfilService,
  ) {
    this.ProfilSorterConfig = ProfilQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
